// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type BusinessHoursFragment = (
  { __typename?: 'OrganisationBusinessHoursModel' }
  & Pick<PrivateSchemaTypes.OrganisationBusinessHoursModel, 'id' | 'enabled'>
  & { days?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'BusinessHoursByDays' }
    & Pick<PrivateSchemaTypes.BusinessHoursByDays, 'sunday' | 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday'>
  )> }
);

export type OrganisationBusinessHoursQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type OrganisationBusinessHoursQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminQueries, 'id'>
      & { businessHours: (
        { __typename?: 'OrganisationBusinessHoursModel' }
        & BusinessHoursFragment
      ) }
    )> }
  )> }
);

export type OrganisationBusinessHoursPatchMutationVariables = PrivateSchemaTypes.Exact<{
  input: PrivateSchemaTypes.OrganisationBusinessHoursModelInput;
}>;


export type OrganisationBusinessHoursPatchMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminMutations, 'id'>
      & { businessHours: (
        { __typename?: 'OrganisationBusinessHoursModel' }
        & Pick<PrivateSchemaTypes.OrganisationBusinessHoursModel, 'id'>
        & { patch: (
          { __typename?: 'OrganisationBusinessHoursModel' }
          & BusinessHoursFragment
        ) }
      ) }
    )> }
  )> }
);

export const BusinessHoursFragmentDoc = gql`
    fragment businessHours on OrganisationBusinessHoursModel {
  id
  enabled
  days {
    sunday
    monday
    tuesday
    wednesday
    thursday
    friday
    saturday
  }
}
    `;
export const OrganisationBusinessHoursDocument = gql`
    query organisationBusinessHours {
  admin {
    organisation {
      id
      businessHours {
        ...businessHours
      }
    }
  }
}
    ${BusinessHoursFragmentDoc}`;

/**
 * __useOrganisationBusinessHoursQuery__
 *
 * To run a query within a React component, call `useOrganisationBusinessHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationBusinessHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationBusinessHoursQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationBusinessHoursQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganisationBusinessHoursQuery, OrganisationBusinessHoursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationBusinessHoursQuery, OrganisationBusinessHoursQueryVariables>(OrganisationBusinessHoursDocument, options);
      }
export function useOrganisationBusinessHoursLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationBusinessHoursQuery, OrganisationBusinessHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationBusinessHoursQuery, OrganisationBusinessHoursQueryVariables>(OrganisationBusinessHoursDocument, options);
        }
export type OrganisationBusinessHoursQueryHookResult = ReturnType<typeof useOrganisationBusinessHoursQuery>;
export type OrganisationBusinessHoursLazyQueryHookResult = ReturnType<typeof useOrganisationBusinessHoursLazyQuery>;
export type OrganisationBusinessHoursQueryResult = Apollo.QueryResult<OrganisationBusinessHoursQuery, OrganisationBusinessHoursQueryVariables>;
export const OrganisationBusinessHoursPatchDocument = gql`
    mutation organisationBusinessHoursPatch($input: OrganisationBusinessHoursModelInput!) {
  admin {
    organisation {
      id
      businessHours {
        id
        patch(input: $input) {
          ...businessHours
        }
      }
    }
  }
}
    ${BusinessHoursFragmentDoc}`;
export type OrganisationBusinessHoursPatchMutationFn = Apollo.MutationFunction<OrganisationBusinessHoursPatchMutation, OrganisationBusinessHoursPatchMutationVariables>;

/**
 * __useOrganisationBusinessHoursPatchMutation__
 *
 * To run a mutation, you first call `useOrganisationBusinessHoursPatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationBusinessHoursPatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationBusinessHoursPatchMutation, { data, loading, error }] = useOrganisationBusinessHoursPatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationBusinessHoursPatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationBusinessHoursPatchMutation, OrganisationBusinessHoursPatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationBusinessHoursPatchMutation, OrganisationBusinessHoursPatchMutationVariables>(OrganisationBusinessHoursPatchDocument, options);
      }
export type OrganisationBusinessHoursPatchMutationHookResult = ReturnType<typeof useOrganisationBusinessHoursPatchMutation>;
export type OrganisationBusinessHoursPatchMutationResult = Apollo.MutationResult<OrganisationBusinessHoursPatchMutation>;
export type OrganisationBusinessHoursPatchMutationOptions = Apollo.BaseMutationOptions<OrganisationBusinessHoursPatchMutation, OrganisationBusinessHoursPatchMutationVariables>;